import { STATUS_META } from "@/lib/mockAdmin";

export const StatusBadge = ({ status, className = "" }) => {
  const meta = STATUS_META[status] || {
    label: status,
    color: "bg-gray-50 text-gray-700 ring-gray-200",
  };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ring-1 ring-inset ${meta.color} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {meta.label}
    </span>
  );
};
